/*
 * @Author: Liux
 * @Date: 2019-09-24 03:30:07
 * @LastEditor: Liux
 * @LastEditTime: 2020-09-16 09:47:42
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdDashboardBoxComponent } from './ad-dashboard-box/ad-dashboard-box.component';
import { TemplateDirective } from './ad-dashboard-box/directive/template.directive';

@NgModule({
  declarations: [AdDashboardBoxComponent, TemplateDirective],
  imports: [CommonModule],
  exports: [AdDashboardBoxComponent, TemplateDirective],
})
export class DashboardModule {}
export { TemplateDirective };
